import { Printer } from "../../models/RestModels";

export function getEmptyPrinter(): Printer
{
		return {
			id: 0,
			created: new Date(),
			created_by_user_id: 0,
			description: '',
			device: 'usb',
			ip_address: '',
			model: 'bixolon-srp350iii',
			name: '',
			port: 0,
			protocol: 'escpos',
			serial_number: '',
			store_id: 0,
			updated: new Date(),
			updated_by_user_id: 0,
			vendor_id: '0x1504',
			// USB Printer Configuration
			product_id: '0x003d',
			interface_number: 0,
			columns: 48,
			codepage_mapping: 'bixolon',
			font_a_columns: 42,
			font_b_columns: 56,
			ticket_id: 0,
			compact_items: false,
			calculation_style: 'NORMAL'
		};
}
